// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'all.admin',
    path: 'M0601Category/form/:id?',
    name: 'PgM0601Form',
    component: () => import('./PgM0601Form')
  },
  {
    portalGroup: 'all.admin',
    path: 'M0601Category/index',
    name: 'PgM0601MultiPage',
    component: () => import('./PgM0601MultiPage')
  }
]
